import product from "./product";

export default {
    product,

    noAvailableItems: "Brak produktów do zamówienia."
}